import getSelectedVariant from '../utils/getSelectedVariant';
import { selectVariant } from './actions';

export default (experiment, userIdentifier) => dispatch => {
  const variant = getSelectedVariant(experiment, userIdentifier);

  dispatch(selectVariant({ name: experiment.name, variant }));

  return variant;
};
